import i18next, { t } from "i18next";
import { useState } from "react";
import ArrowIcon from "../../../../assets/images/icons/arrow-down.svg";
import { GeneralButton, Modal } from "../../../../components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFileCount } from "../../../../redux/reducers/investigationFilesSlice";

const CancelMedicalRecord = ({
  onClick,
  arrowStyle,
}: {
  arrowStyle?: boolean;
  onClick: () => void;
}) => {
  const { type } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()

  const handleBack = () => {
    navigate(location.state?.from || -1);
  };

  const [isCancelOpen, setIsCancelOpen] = useState<boolean>(false);

  return (
    <div>
      {arrowStyle ? (
        <div
          onClick={() => {
            setIsCancelOpen(true);
          }}
          className="h-6 w-6 rounded-full bg-primary"
        >
          <img
            src={ArrowIcon}
            alt=""
            className={`brightness-0 invert ${i18next?.language === "ar" ? "-rotate-90" : "rotate-90"
              } `}
          />
        </div>
      ) : (
        <GeneralButton
          onClick={() => {
            dispatch(resetFileCount());
            type === "details" ? handleBack() : setIsCancelOpen(true);
          }}
          color="lite"
          title={t("cancel")}
          className={`!text-primary-text ms-auto !bg-white`}
        />
      )}

      <Modal
        isOpen={isCancelOpen}
        onClose={() => {
          setIsCancelOpen(false);
        }}
        customStyle="!gap-2"
        header={t("cancel_medical_record_adding")}
      >
        <p className="text-secondaryDark">
          {t("cancel_medical_record_adding_confirmation")}
        </p>
        <div className="mt-16 flex items-center justify-end gap-2">
          <GeneralButton
            color="gray"
            title={t("keep_adding")}
            onClick={() => {
              setIsCancelOpen(false);
            }}
          />
          <GeneralButton
            color="red"
            title={t("cancel_process")}
            onClick={onClick}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CancelMedicalRecord;
